import { createSelector } from 'reselect';

const selectStartPageContent = (state) => {
    const ref = state.iContentRepo.refs.startPage;
    return state.iContentRepo.items[ref]?.content;
  };
  
  export const getEpiFolderName = createSelector(
    [selectStartPageContent],
    (content) => content?.imagesMediaFolder?.expandedValue?.routeSegment
  );

  export const selectEpiImagesSet = createSelector(
    [selectStartPageContent],
    (content) => {
      const imagesArray = content?.epiFolderImages?.value || [];
      return new Set(imagesArray);
    }
  );